import {getState, WritableStateSource} from '@ngrx/signals';
import {EmptyFeatureResult, InnerSignalStore} from '@ngrx/signals/src/signal-store-models';

import {SignalStoreNameType, SignalStoreState} from '../../data';

export const SIGNAL_STORE_METADATA_KEY = 'SignalStoreMetaData' as const;

export type SignalStoreMetaData = {
	readonly StoreName: SignalStoreNameType;
	readonly [key: string]: any;
};
type WithMetaDataFeatureState = SignalStoreState<{
	state: SignalStoreState & {
		[SIGNAL_STORE_METADATA_KEY]: SignalStoreMetaData;
	};
	methods: {
		getMetaData: () => SignalStoreMetaData;
	};
}>;

export type WithMetaDataFeatureOutput = EmptyFeatureResult & WithMetaDataFeatureState;

export type WithMetaAllowedTypes = StoreState | InnerSignalStore<WithMetaDataFeatureOutput> | WritableStateSource<SignalStoreState>;

/**
 * Checks if the given store has the meta-data feature.
 *
 * @param store - The store to check.
 * @returns True if the store has the meta-data feature, otherwise false.
 */
export function isWithMetaDataFeature(store: WithMetaAllowedTypes): store is WithMetaAllowedTypes {
	const state = getState(store);
	return SIGNAL_STORE_METADATA_KEY in state && typeof state[SIGNAL_STORE_METADATA_KEY] === 'object';
}

/**
 * Retrieves the meta-data from the given store.
 *
 * @param store - The store from which to retrieve the meta-data.
 * @returns The meta-data if the store has the meta-data feature, otherwise undefined.
 */
export function getSignalStoreMetaData(store: InnerSignalStore<SignalStoreState>): SignalStoreMetaData {
	if (isWithMetaDataFeature(store)) return getState(store)[SIGNAL_STORE_METADATA_KEY];
	throw new Error('Store does not have the meta-data featuren\n\n' + JSON.stringify(store));
}
